import SecurityUserDTO from "@/dto/user/SecutityUserDTO";
import mainServerClient from "@/services/http/mainServerClient";

export function getCurrentUser() {
    return mainServerClient.get<SecurityUserDTO>("/security/currentUser");
}

export default { getCurrentUser };
